/**
 * Система типографики проекта
 *
 * Определяет все используемые стили текста с единой точкой управления.
 * Варианты соответствуют дизайн-системе: Heading XL/L/M/S, Text L/M/S/XS, Accent L/M/S/XS.
 */
export const typography = {
  // Заголовки (Headings)
  'heading-xl': {
    desktop: 'text-[56px] leading-[68px] font-medium tracking-[-0.56px]',
    mobile: 'max-sm:text-[40px] max-sm:leading-[44px] max-sm:tracking-[-0.8px]',
  },
  'heading-l': {
    desktop: 'text-[44px] leading-[52px] font-medium tracking-[-0.44px]',
    mobile: 'max-sm:text-[30px] max-sm:leading-[38px] max-sm:tracking-[-0.3px]',
  },
  'heading-m': {
    desktop: 'text-[30px] leading-[38px] font-medium tracking-[-0.45px]',
    mobile:
      'max-sm:text-[24px] max-sm:leading-[28px] max-sm:tracking-[-0.24px]',
  },
  'heading-s': {
    desktop: 'text-[24px] leading-[32px] font-medium tracking-[-0.12px]',
    mobile: 'max-sm:text-[20px] max-sm:leading-[24px] max-sm:tracking-[-0.1px]',
  },
  'heading-xs': {
    desktop: 'text-[18px] leading-[28px] font-medium tracking-[-0.18px]',
    mobile: 'max-sm:text-[16px] max-sm:leading-[24px] max-sm:tracking-[-0.1px]',
  },

  // Текст (Text)
  'text-base': {
    desktop: 'text-[16px] leading-[24px] tracking-[-0.16px] font-normal',
  },
  'text-l': {
    desktop: 'text-[18px] leading-[28px] font-normal tracking-[-0.18px]',
    mobile:
      'max-sm:text-[16px] max-sm:leading-[24px] max-sm:tracking-[-0.16px]',
  },
  'text-m': {
    desktop: 'text-[16px] leading-[24px] font-normal tracking-[-0.16px]',
    mobile: 'max-sm:text-[14px] max-sm:leading-[20px]',
  },
  'text-s': {
    desktop: 'text-[14px] leading-[20px] font-normal',
    mobile: 'max-sm:text-[12px] max-sm:leading-[16px]',
  },
  'text-xs': {
    desktop: 'text-[12px] leading-[14px] font-normal',
    mobile: 'max-sm:text-[10px] max-sm:leading-[14px]',
  },

  // Акцент (Accent)
  'accent-base': {
    desktop: 'text-[16px] leading-[24px] font-medium',
  },
  'accent-l': {
    desktop: 'text-[18px] leading-[28px] font-medium tracking-[-0.18px]',
    mobile:
      'max-sm:text-[16px] max-sm:leading-[20px] max-sm:tracking-[-0.16px]',
  },
  'accent-m': {
    desktop: 'text-[16px] leading-[24px] font-medium tracking-[-0.16px]',
    mobile:
      'max-sm:text-[14px] max-sm:leading-[20px] max-sm:tracking-[-0.14px]',
  },
  'accent-s': {
    desktop: 'text-[14px] leading-[20px] font-medium',
    mobile: 'max-sm:text-[12px] max-sm:leading-[16px]',
  },
  'accent-xs': {
    desktop: 'text-[12px] leading-[14px] font-medium',
    mobile: 'max-sm:text-[10px] max-sm:leading-[14px]',
  },
} as const;

export type TypographyVariant = keyof typeof typography;

/**
 * Получить классы для типографики
 */
export const getTypographyClasses = (variant: TypographyVariant): string => {
  const styles = typography[variant];

  return Object.values(styles).join(' ');
};
